import { getPrixCadre } from "../profcadresprix/index-legacy"

export const get_product_to_add = (nameService, service, product, quantite, largeur, hauteur, kit_montage_checked) => {
  let description = "<b>Ref: " + product.bas_reference + "</b> " + product.fa_libelle + "<br />"

  description += "Dimensions intérieures : "
  description +=
    largeur +
    " cm X " +
    hauteur +
    " cm <br />" +
    product.ba_descriptif +
    "<br /> Service : " +
    (typeof service !== "undefined" && service !== null ? service.title : "") +
    "<br />"
  if (typeof service !== "undefined" && service !== null && service.option_carton_barriere_checked) {
    description += "<br /> - un carton barrière"
  }

  if (kit_montage_checked == 1) {
    description += "<br /> - un kit de montage"
  }

  if (["coupe_assemble", "precoupe"].includes(nameService) && [4, 7, 14, 9, 8, 1, 15, 21].includes(product.cat_id)) {
    description += "<br />Cadre livré sans accroches ni tournettes (à commander séparément dans la rubrique accessoires)"
  }

  if (nameService === "coupe_assemble") {
    description += "<br />Cadre livré sans verre et sans isorel"
  }
  if (nameService === "coupe_assemble_isorel") {
    description += "<br />Cadre livré sans verre"
  }

  description += "<br />Fabriqué à vos mesures dans nos ateliers de Besançon"

  product.descriptif_produit = description
  product.ba_qty = quantite
  product.prix_produit = typeof service !== "undefined" && service !== null ? parseFloat(service.prix_unitaire_with_options_ht * 1.2).toFixed(2) : 0
  product.cadreLargeur = largeur
  product.cadreHauteur = hauteur
  product.nameService = nameService
  product.type = "baguette"
  return product
}

export const get_passe_to_add = (product, prix, quantite, largeur, hauteur, largeur_int, hauteur_int) => {
  var description = ""

  if (description === "") {
    description += product.pa_description + " <br />" + "Dimension hors tout " + largeur + " x " + hauteur + " cm <br /> "
    description += "Dimensions de la fenêtre image : " + largeur_int + " x " + hauteur_int + " cm <br /> "
    description += "Réf. " + quantite + " <br /> "
    description += "avec marges <br /> "
    description += "haut : " + (hauteur / 2 - hauteur_int / 2).toFixed(2) + " <br /> "
    description += "droit : " + (largeur / 2 - largeur_int / 2).toFixed(2) + " <br /> "
    description += "bas : " + (hauteur / 2 - hauteur_int / 2).toFixed(2) + " <br /> "
    description += "gauche : " + (largeur / 2 - largeur_int / 2).toFixed(2) + " <br /> "
    description += "Découpe numérique réalisée dans nos ateliers de Besançon. <br /> "
  }

  product.descriptif_produit = description
  product.ba_qty = quantite
  product.prix_produit = prix
  product.cadreLargeur = largeur
  product.cadreHauteur = hauteur
  product.cadreLargeur_int = largeur_int
  product.cadreHauteur_int = hauteur_int
  product.ba_id = product.pa_id
  product.reference = product.pa_reference
  product.nameService = "passe_partout"
  product.type = "passe_partout"
  return product
}

export const get_accessoire_to_add = (product, prix, quantite) => {
  var description = ""

  if (description === "") {
    description += product.pa_libelle + " <br />"
    description += "Réf. " + product.pa_reference + "<br />"
  }

  product.descriptif_produit = description
  product.ba_qty = quantite
  product.prix_produit = prix
  product.ba_id = product.pa_id
  product.nameService = "accessoire"
  product.type = "accessoire"
  return product
}

/**
 *
 * @param {object} product node du produit
 * @param {object} pageProduit reducer ou contenu stocké dans le panier
 * @param {object} pa produits annexes (bruts sql)
 * @param {object} photosR reducer ou contenu stocké dans le panier
 */
export const getPrix = (product, pageProduit, pa, photosR = { photos: [] }) => {
  if (typeof product.ba_id !== "undefined") {
    return getPrixCadre(
      product,
      pageProduit,
      pa.map(e => e.node),
      photosR
    )
  } else {
    if (typeof product.pa_plaque_longueur !== "undefined") {
      // Calcul passe partout

      //console.log(pa)
      //console.log(pa.find(u => u.pa_id === 11))
      return getPrixCadre(
        { ba_id: 2353, ba_prix_fourniture: 0, bm_marge_coupe_assemble: 0, ba_prix: 0, ba_prix_majoration: 0, ba_talon: 0, ba_largeur: 0, ba_chutes: 0 }, // Baguette de calcul pp
        { ...pageProduit, isorel: false, protection: "aucune", pp: {...pageProduit.pp, pp: product} },
        pa,
        { photos: [] }
      )
    } else {
      // Calcul prix accessoire :
      return parseFloat(product.pa_prix_vente_ht) * 1.43 * 1.2
    }
  }
}
